import style from './style';
import { stopBubble, trackLaunchAppAction, trackEvent } from '../../utils/common';
import { utils } from '../../../utils';
const { copy } = utils;
const { rootViewStyle, containerViewStyle, titleTextStyle, contentTextStyle, btnImgStyle, closeBtnImgStyle } = style;
const getDomTree = function (viewInstance, link, callback) {
    const vDom = {
        domKey: 'rootView',
        tag: 'div',
        props: { class: 'launch-app-passphrase-view' },
        style: rootViewStyle,
        events: { click: () => viewInstance.removeUI('rootView') },
        children: [
            {
                domKey: 'containerView',
                tag: 'div',
                style: containerViewStyle,
                events: { click: (e) => stopBubble(e) },
                children: [
                    {
                        domKey: 'titleText',
                        tag: 'div',
                        text: '无法打开？',
                        style: titleTextStyle,
                    },
                    {
                        domKey: 'contentText',
                        tag: 'div',
                        text: '可能是当前应用不支持唤醒我们，试试 复制滴口令后打开【滴滴出行APP】查看吧～',
                        style: contentTextStyle,
                    },
                    {
                        domKey: 'btnImg',
                        tag: 'img',
                        props: { class: 'copy-passphrase-btn', src: 'https://ut-static.udache.com/webx/ut/lC_ooriBNd-_0sJu6lFWo.png' },
                        style: btnImgStyle,
                        events: {
                            click: (e) => {
                                stopBubble(e);
                                copy(link).then(() => {
                                    callback && callback(true);
                                }).catch(() => {
                                    callback && callback(false);
                                });
                                updateDomTree(viewInstance);
                                trackEvent('launch_app_passphrase_copy_btn_click', { link });
                                trackLaunchAppAction(link);
                            }
                        }
                    }
                ]
            }
        ]
    };
    return vDom;
};
const updateDomTree = function (viewInstance) {
    viewInstance.updateNode('titleText', {
        text: '复制成功',
        style: { marginTop: '7.07vw' },
    });
    viewInstance.updateNode('contentText', {
        text: '打开【滴滴出行APP】去试试吧～',
        style: { margin: '4.67vw auto 20vw' },
    });
    viewInstance.removeUI('btnImg');
    const vDom = {
        domKey: 'closeBtnImg',
        tag: 'img',
        props: { class: 'close-popup-btn', src: 'https://ut-static.udache.com/webx/ut/YlJIrHx85yY5zwyBRlDQs.png' },
        style: closeBtnImgStyle,
        events: {
            click: () => {
                trackEvent('launch_app_passphrase_close_popup_btn_click');
                viewInstance.removeUI('rootView');
            }
        }
    };
    viewInstance.createUI(vDom, viewInstance.containerView);
    trackEvent('launch_app_passphrase_copy_success_popup_expose');
};
export default getDomTree;
